import {Event} from "../../../GAnalytics";

export function setGroups(groups) {
	Event('Documents', 'setGroups', 'Definiu grupos: ' + JSON.stringify(groups));
	return {
		type: "SET_DOCUMENTS_FILTER_GROUPS",
		groups
	};	
}

export function setVisibility(visibility) {
	Event('Documents', 'setVisibility', 'Definiu a visibilidade: ' + visibility);
	return {
		type: "SET_DOCUMENTS_FILTER_VISIBILITY",
		visibility
	};	
}

export function setWholeWordOnly(wholeWord) {
	Event('Documents', 'setWholeWordOnly', 'Definiu a busca para: ' + wholeWord);
	return {
		type: "SET_DOCUMENTS_WHOLE_WORD",
		wholeWord
	};	
}

export function setFolder(folder) {
	Event('Documents', 'setFolder', 'Definiu a pasta: ' + JSON.stringify(folder));
	return {
		type: "SET_DOCUMENTS_FILTER_FOLDER",
		folder
	};	
}

export function setSectors(sectors) {
	Event('Documents', 'setSectors', 'Definiu setores: ' + JSON.stringify(sectors));
	return {
		type: "SET_DOCUMENTS_FILTER_SECTORS",
		sectors
	};	
}

export function setLocalities(localities) {
	Event('Documents', 'setLocalities', 'Definiu localities: ' + JSON.stringify(localities));
	return {
		type: "SET_DOCUMENTS_FILTER_LOCALITIES",
		localities
	};	
}

export function setKeywords(keywords) {
	Event('Documents', 'setKeywords', 'Definiu palavras-chave: ' + JSON.stringify(keywords));
	return {
		type: "SET_DOCUMENTS_FILTER_KEYWORDS",
		keywords
	};	
}

export function setSearchTerms(terms) {
	Event('Documents', 'setSearchTerms', 'Definiu palavras-chave: ' + JSON.stringify(terms));
	return {
		type: "SET_DOCUMENTS_FILTER_TERMS",
		terms
	};	
}


// WEBPACK FOOTER //
// ./src/state/documents/filter/actions.js